import { Badge } from "../ds";
import { ESTADOS_MENSAJE, estadoLead } from "../formato";
import type { EstadoLead, EstadoMensaje } from "../tipos";

export function BadgeLead({ estado, size = "sm" }: { estado: EstadoLead; size?: "sm" | "md" }) {
  const e = estadoLead(estado);
  return (
    <Badge tone={e.tono} size={size}>
      {e.etiqueta}
    </Badge>
  );
}

export function BadgeMensaje({ estado }: { estado: EstadoMensaje }) {
  const e = ESTADOS_MENSAJE[estado];
  return (
    <Badge tone={e.tono} size="sm" dot>
      {e.etiqueta}
    </Badge>
  );
}

export function BadgeCanal({ canal }: { canal: "email" | "whatsapp" }) {
  return (
    <Badge tone="neutral" size="sm" icon={canal === "email" ? "mail" : "whatsapp"}>
      {canal === "email" ? "Email" : "WhatsApp"}
    </Badge>
  );
}
